import { jsx as _jsx } from "react/jsx-runtime";
import ToolTip from './ToolTip/ToolTip';
function ButtonToolTip({ children, style = { padding: '5px' }, onClick = () => null, popupTitle = '', popupPlacement = 'right', ...props }) {
    return (_jsx(ToolTip, { title: popupTitle, popupPlacement: popupPlacement, children: _jsx("button", { style: style, type: "button", onClick: onClick, ...props, children: children }) }));
}
export default ButtonToolTip;
